/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, page }) {
    const paramsObj = { searchKey: page };
    const searchParams = new URLSearchParams(paramsObj);
    let url =
      typeof searchKey === 'string'
        ? `${this.url}?search=${searchKey}`
        : this.url;
    let prefix = searchParams.has('searchKey') ? '?' : '&';
    if (page) url += `${prefix}page=${page}`;
    return axios.get(url);
  }
}

export default new CannedResponse();
